import React from "react";
import Problem from "../parts/Problem";
import Modal from "./Modal";
// import { GoogleMap } from '@react-google-maps/api';

// const containerStyle = {
//   width: '400px',
//   height: '400px'
// };

// const center = {
//   lat: 35.6804,
//   lng: 139.769,
// };


// https://www.google.com/maps/embed/v1/view?zoom=17&center=48.7230%2C44.5338&key=AIzaSyCUeLeu4JVZAc0gjpxTC-hjfnyosPlsvFs


export default function Contacts() {
document.getElementById("map").style.display = "block"

    return (<>
<Modal/>
        <div id="contacts_" className="container-fluid">
            <div className="row" >
                <div className="col-sm-5" >
                    <div id="contacttitle">Контакты</div>
                    <div className="container-fluid contactblock">
                        <div className="row">
                            <div className="col-sm-2 margpadlr"><img src="../images/geo.png"/></div>
                            <div className="col-sm-10 margpadlr">
                                <div id="contactmini">Адрес:</div>
                                <div id="contacttext">г. Волгоград, ул. 7-я Гвардейская д. 2<br/>
                                    офис 218 (2 этаж)</div>
                                </div>
                        </div>
                    </div>
                
             
                    <div className="container-fluid contactblock">
                        <div className="row">
                            <div className="col-sm-2 margpadlr"><img src="../images/phonecircle.png"/></div>
                            <div className="col-sm-10 margpadlr">
                                <div id="contactmini">Телефон:</div>
                                <div id="contacttext">+7 999 999 99 99</div>
                                </div>
                        </div>
                    </div>

                <div className="container-fluid contactblock">
                        <div className="row">
                            <div className="col-sm-2 margpadlr"><img src="../images/time.png"/></div>
                            <div className="col-sm-10 margpadlr">
                                <div id="contactmini">Время работы:</div>
                                <div id="contacttext">C 10:00 до 20:00</div>
                                </div>
                        </div>
                    </div>

                    <div id="contactsoc">
                        <a href="#"><img src="../images/tg.png" /></a>
                        <a href="#"><img src="../images/vkorange.png" /></a>
                        <a href="#"><img src="../images/igorange.png" /></a>
                        <a href="#"><img src="../images/twitorange.png" /></a>
                        <a href="#"><img src="../images/fborange.png" /></a>
                        
                    </div>

                </div>
     
{/*                   
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
      />
         */}

     
            </div>
        </div>
        <Problem/>
        </>
    )
}
